import {moreinfo} from "./index"

export const Wdata = [
  {
    id: 1,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext:
      "Am I properly insured? Can I optimize my contracts? Do I end up paying too much?",
  },
  {
    id: 2,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext:
      "What is my financial situation like in the event of illness, care or disability?",
  },
  {
    id: 3,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext: "Should I continue to rent or can I afford a property?",
  },
  {
    id: 4,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext: "How can I reduce taxes and social security contributions?",
  },

  {
    id: 5,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext: "How can I save more without giving up a good life?",
  },
];

export const WdataSecond = [
  {
    id: 6,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext:
      "What alternatives are there to the savings book? Is my money well spent?",
  },
  {
    id: 7,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext: "How can I reduce taxes and social security contributions?",
  },
  {
    id: 8,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext: "How can I use government funding?",
  },
  {
    id: 9,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext:
      "What alternatives are there to the savings book? Is my money well spent?",
  },
  {
    id: 10,
    wicon: "https://i.postimg.cc/0yGrTP2X/check.png",
    wtext: "How can I protect my money from inflation?",
  },
];

export const ProductData = [
  {
    id: 1,
    moreinfosrc: `${moreinfo}`,
    serviceimg: "https://i.ibb.co/WzfC1jn/img.jpg",
    title: "Benefit from government subsidies and save taxes",
  },
  {
    id: 2,
    moreinfosrc: `${moreinfo}`,
    serviceimg: "https://i.ibb.co/WzfC1jn/img.jpg",
    title: "Benefit from government subsidies and save taxes",
  },

  {
    id: 3,
    moreinfosrc: `${moreinfo}`,
    serviceimg: "https://i.ibb.co/WzfC1jn/img.jpg",
    title: "Benefit from government subsidies and save taxes",
  },
  {
    id: 4,
    moreinfosrc: `${moreinfo}`,
    serviceimg: "https://i.ibb.co/WzfC1jn/img.jpg",
    title: "Benefit from government subsidies and save taxes",
  },
  {
    id: 5,
    moreinfosrc:`${moreinfo}`,
    serviceimg: "https://i.ibb.co/WzfC1jn/img.jpg",
    title: "Benefit from government subsidies and save taxes",
  },
  {
    id: 6,
    moreinfosrc:`${moreinfo}`,
    serviceimg: "https://i.ibb.co/WzfC1jn/img.jpg",
    title: "Benefit from government subsidies and save taxes",
  },
];
